import { ACCEPT_RATIO, DECLINE_RATIO, DISTRIBUTION, MONTH_NAMES, WEEKS } from '../../constants';

const calculateResponses = (guestsValue, dateValue) => {
  let label_dates = [];
  let responses_by_date;
  let week_accept_data = [];
  let week_decline_data = [];
  let total_accepts = 0;
  let total_declines = 0;
  let total_responses = 0;

  for (let i = 0; i < WEEKS; i++) {
    total_responses = total_responses + Math.floor(guestsValue * DISTRIBUTION[i]);
    let week_responses = Math.floor(guestsValue * DISTRIBUTION[i]);
    let week_accept = Math.round(week_responses * ACCEPT_RATIO);
    let week_decline = Math.round(week_responses * DECLINE_RATIO);

    total_declines = total_declines + week_decline;
    total_accepts = total_accepts + week_accept;

    if(i === 9)
    {
      let left_over = guestsValue - total_responses;
      total_accepts =  total_accepts + left_over;
      total_responses = total_responses + left_over;
    }

    week_accept_data.push(total_accepts)
    week_decline_data.push(total_declines)

    let d = new Date(dateValue);
    d.setDate(d.getDate() + (i*7));
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let final_date = (`${MONTH_NAMES[month]} ${day}, ${year}`);
    label_dates.push([`Week ${(i + 1)}`, `${MONTH_NAMES[month]} ${day}`, `${year}`])
    if(i === 6){
      responses_by_date = final_date
    }
  }

  return {
    week_accept_data,
    week_decline_data,
    label_dates,
    responses_by_date
  }
}

export default calculateResponses
